import { render } from "./InvoiceCreateConceptModal.vue?vue&type=template&id=ba2c1f74"
import script from "./InvoiceCreateConceptModal.vue?vue&type=script&lang=js"
export * from "./InvoiceCreateConceptModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__